<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g opacity="0.8">
      <rect width="40" height="40" rx="20" fill="white" />
      <path
        d="M26.7034 19.7504C26.7379 23.3824 29.9643 24.591 30 24.6065C29.9727 24.6917 29.4845 26.3289 28.3002 28.0199C27.2764 29.482 26.2139 30.9386 24.5401 30.9688C22.8955 30.9984 22.3666 30.0159 20.4863 30.0159C18.6066 30.0159 18.019 30.9386 16.4621 30.9984C14.8465 31.0582 13.6162 29.4174 12.5839 27.9608C10.4746 24.9811 8.86269 19.5409 11.0271 15.8687C12.1024 14.0451 14.0239 12.8903 16.1096 12.8607C17.6961 12.8311 19.1936 13.9036 20.1634 13.9036C21.1327 13.9036 22.9524 12.6139 24.8654 12.8033C25.6663 12.8358 27.9143 13.1194 29.3579 15.1839C29.2415 15.2544 26.6755 16.714 26.7034 19.7504ZM23.6124 10.832C24.4702 9.81747 25.0475 8.4052 24.89 7C23.6536 7.04855 22.1586 7.80502 21.2717 8.81896C20.477 9.71684 19.7809 11.154 19.9687 12.5314C21.3468 12.6355 22.7546 11.8471 23.6124 10.832Z"
      />
    </g>
  </svg>
</template>
